import axios from 'axios';
import { store } from 'store';
import { CLIENT_THEME } from 'utils/clientTheme';
import { hasAccessToMultipleCustomers } from 'utils/validators/role.validation';

export interface CustCodeCustomerConfig {
  primaryElement?: string | null;
}

interface CustomerConfigRequest {
  custCode: string;
}

const getCustomerConfig = async (
  custCode: string
): Promise<CustCodeCustomerConfig> => {
  const state = store.getState();
  const accessToken = state.authReducer.accessToken;
  const role = state.authReducer.role;
  const customerId = state.persistedReducer.customer.id;

  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_MANAGEMENT_API_URL ?? ''}/api/`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'x-client-theme': CLIENT_THEME,
    },
    params: {
      ...(hasAccessToMultipleCustomers(role as any) && { customerId }),
    },
  });

  const payload: CustomerConfigRequest = { custCode };

  const response = await axiosInstance.post<CustCodeCustomerConfig>(
    'device/customer-config',
    payload
  );

  return response.data;
};

export default { getCustomerConfig };
